module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('HomePageCard', {
    staticClass: "platform-notices",
    attrs: {
      "title": _vm.title,
      "extra": "更多"
    },
    on: {
      "extraClick": function($event) {
        _vm.$emit('extraClicked')
      }
    }
  }, [_c('ul', {
    staticClass: "notice-list"
  }, _vm._l((_vm.notices), function(noticeItem) {
    return _c('NoticeItem', {
      key: noticeItem.id,
      attrs: {
        "isNew": noticeItem.isNew,
        "name": noticeItem.name,
        "date": noticeItem.date
      },
      on: {
        "itemClicked": function($event) {
          _vm.noticeClicked(noticeItem.id)
        }
      }
    })
  }))])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-971502a6","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/homepage/notices.vue
// module id = 747
// module chunks = 0